import * as z from "zod";
import "../../components/button/StyledButton.css"
import AddEcomForm from "components/addEcomForm/AddEcomForm";
import { useGetEcomLatestQuery } from "api/api";
import { createEcomFieldValidation } from "./helpers";

const AddEcomReinforcementPage = () => {
  const { data: latestEcomData = [] } = useGetEcomLatestQuery();
  const filteredEcomData = latestEcomData['ECOMData'].filter(data => data.material_category === 'Steel Reinforcement');
  const materialMapping = filteredEcomData.reduce((accumulator, material) => {
    accumulator[material.material_type] = material.a1_a3_carbon_factor;
    return accumulator;
  }, {});

  const inputLabels = [
    { name: "rebar", label: "Rebar", unit: "kgCO2e/ton", value: null, type: 'number', latestValue: materialMapping['Rebar'], component: "FormTextField" },
    { name: "welded_wire_reinforcement", label: "Welded Wire Reinforcement", unit: "kgCO2e/ton", value: null, type: 'number', latestValue: materialMapping['Welded Wire Reinforcement'], component: "FormTextField" },
    { name: "post_tensioning", label: "Post Tensioning", unit: "kgCO2e/ton", value: null, type: 'number', latestValue: materialMapping['Post Tensioning'], component: "FormTextField" },
  ];

  const inputNames = inputLabels.map((input) => input.name)

  const schema = z.object(
    Object.fromEntries(
      inputNames.map(key => [key, createEcomFieldValidation(key)])
    )
  );

  return (
    <AddEcomForm
      title="Steel Reinforcement"
      inputLabels={inputLabels}
      stage={3}
      validationSchema={schema}
    />
  );
}

export default AddEcomReinforcementPage;